package ui.merchantInformation

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.filled.Settings
import androidx.compose.material3.Icon
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.flow.StateFlow
import model.DataRepository
import model.MerchantFullInformationV3
import ui.Colors
import ui.pullToRefresh.PullRefreshIndicator
import ui.pullToRefresh.pullRefresh
import ui.pullToRefresh.rememberPullRefreshState
import ui.scrollbar.LazyColumnScrollbar

@Composable
fun MerchantInformationScreen(
    viewModel: MerchantInformationViewModel = merchantInformationViewModel(),
    merchantCardView: @Composable (merchantInformationStateFlow: StateFlow<MerchantFullInformationV3?>, (MerchantFullInformationV3) -> Unit) -> Unit,
) {
    val merchantInformationStateFlow = viewModel.merchantInformationStateFlow
    val paymentStateStateFlow = viewModel.paymentsStateFlow
    val cardsStateFlow = viewModel.cardsStateFlow
    val shouldShowScrollbar = viewModel.clientConfig.shouldShowScrollBar

    Box(
        modifier = Modifier
            .height(100.dp)
            .fillMaxWidth()
            .background(Colors.Primary)
    )
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        merchantCardView(merchantInformationStateFlow) {}
        Box(modifier = Modifier.fillMaxWidth()){
            val shouldDisplayDemoAdminCards = merchantInformationStateFlow.value?.shouldDisplayAdminDemoCards ?: false
            if (shouldDisplayDemoAdminCards) {
                Box(
                    modifier = Modifier
                        .align(Alignment.TopEnd)
                        .padding(vertical = 16.dp, horizontal = 16.dp)
                        .clickable {
                            viewModel.setDemoAdmin(merchantInformationStateFlow.value?.consumerLoyaltyProgramGuid.orEmpty())
                        }
                ) {
                    Icon(
                        Icons.Default.Settings,
                        contentDescription = null
                    )

                }
            }
            Text(
                "Transactions",
                fontWeight = FontWeight.Bold,
                modifier = Modifier
                    .align(Alignment.Center)
                    .padding(start = 16.dp, top = 16.dp, bottom = 16.dp),
            )
        }


        Box(modifier = Modifier.fillMaxWidth()) {
            val paymentState by paymentStateStateFlow.collectAsState()
            val lazyListState = rememberLazyListState()

            val pullRefreshState = rememberPullRefreshState(
                refreshing = paymentState is DataRepository.PaymentState.Refreshing,
                onRefresh = viewModel::loadPaymentsAsync,
            )
            Column {
                LazyColumnScrollbar(
                    listState = lazyListState,
                    padding = 4.dp,
                    alwaysShowScrollBar = shouldShowScrollbar
                ){
                    LazyColumn(
                        state = lazyListState,
                        modifier = Modifier
                            .pullRefresh(pullRefreshState)
                            .padding(horizontal = 16.dp)
                        ,
                    ) {
                        items(paymentState.payments) {
                            TransactionView(it, viewModel::setEreceipt, cardsStateFlow)
                        }
                    }
                }
            }
            PullRefreshIndicator(
                refreshing = paymentState is DataRepository.PaymentState.Refreshing,
                state = pullRefreshState,
                modifier = Modifier.align(Alignment.TopCenter),
            )
        }

    }
}